import dynamic from 'next/dynamic';
import { Fragment, useState } from 'react';
import styled from 'styled-components';

import { t } from 'localization/utils/t';

const InstantShipModal = dynamic(
  () => import('productTemplate/components/modals/InstantShipModal'),
  { ssr: false },
);

const TP = 'productTemplate.components.buyBar.NewSection';

export const InstantShipDescription = ({ instantCopy, id }) => {
  const [isInstantShipModalOpen, setIsInstantShipModalOpen] = useState<boolean>(false);

  if (!instantCopy) return null;

  const handleInstantShipClose = () => {
    setIsInstantShipModalOpen(false);
  };

  const handleToggleInstantShipModal = (e) => {
    // link inside a clickable table row
    e.stopPropagation();
    setIsInstantShipModalOpen((value) => !value);
  };

  const priorityProcessing = t(`${TP}.priorityProcessing`, 'priority processing');
  const containsPriorityProcessing = new RegExp(`(${priorityProcessing})+`, 'i');
  const instantCopyArr = instantCopy.split(containsPriorityProcessing);

  return (
    <InstantShipDescription.Wrapper>
      <div className="instantShipDescription" data-qa="open_instant_ship_window_button">
        {instantCopyArr.map((text) =>
          containsPriorityProcessing.test(text) ? (
            <a
              className="instantShipPriorityProcessing"
              key={text}
              onClick={handleToggleInstantShipModal}
              onKeyDown={handleToggleInstantShipModal}
              role="button"
              tabIndex={0}
            >
              {priorityProcessing}
            </a>
          ) : (
            <Fragment key={text}>{text}</Fragment>
          ),
        )}
      </div>
      {isInstantShipModalOpen && (
        <InstantShipModal productTemplateId={id} onClose={handleInstantShipClose} />
      )}
    </InstantShipDescription.Wrapper>
  );
};

InstantShipDescription.Wrapper = styled.div`
  button {
    padding: 0;
    text-align: left;
  }

  .instantShipPriorityProcessing {
    text-decoration: underline;
    cursor: pointer;
  }
`;
